import AppCard, { ExtendedCloudApp } from "../../Cards/AppCard";
import AppEmptyState from "../../../../elements/AppEmptyState";

interface Props {
  cloudApps?: ExtendedCloudApp[];
  tenantID: any;
  isAdmin: boolean;
  openApp: (appID: string) => void;
}

const MyLocalApps = ({ cloudApps, openApp }: Props) => {
  const handleClick = (app: ExtendedCloudApp) => {
    if (app._id) {
      openApp(app._id);
    }
  };

  if (!cloudApps) return null;

  return (
    <div className="tw:flex tw:flex-col tw:px-3 tw:sm:px-6 tw:pt-5">
      <div className="tw:mx-2 tw:py-3 tw:mb-4 tw:border-b tw:border-superlight">
        <h3 className="tw:text-black">My Cloud Apps</h3>
        <small>Apps that are only available for this cloud</small>
      </div>
      <div className="tw:flex tw:flex-wrap tw:justify-center tw:md:justify-start tw:gap-6">
        {cloudApps.length ? (
          cloudApps.map((cloudApp: ExtendedCloudApp) => {
            return (
              <AppCard
                key={cloudApp.id}
                app={cloudApp}
                onClick={() => handleClick(cloudApp)}
              />
            );
          })
        ) : (
          <AppEmptyState
            title="No Cloud Apps Available"
            description="There are no cloud apps to install."
            className="tw:w-full"
          />
        )}
      </div>
    </div>
  );
};

export default MyLocalApps;
